import { DropItems, DragItems } from '../../types';
import { DropBox } from '../DropBox';
import { Computer } from './components/Computer';
import { Trash } from './components/Trash';
import styles from './styles.module.scss';

export type computerOrTrash = 'trash' | 'computer';

type ComputerAndTrashProps = {
    name: string;
    id?: number;
    component: computerOrTrash;
    validateOnDrop: any;
    type: 'checkBox' | 'varType' | 'code' | 'trash' | String;
    onclick?: any;
    pos: {x:number,y:number};
    scale: number;
    isLogicMaker?: any;
    css?: any;
    dropArea?: any;
    size;
};

export const ComputerAndTrash = ({
    name,
    css,
    type,
    component,
    validateOnDrop,
    onclick,
    pos,
    id,
    scale,
    dropArea,
    size,
    isLogicMaker
}: ComputerAndTrashProps) => {
    return (

        isLogicMaker? <Trash dropArea={dropArea}  css = {css} onclick = {onclick} pos={pos} scale={scale} size={size} isLogicMaker={isLogicMaker} /> :
        <DropBox
            key={name}
            className={
                component === 'trash'
                    ? `${styles.box} ${styles.boxDrop} ${styles.boxDropTrash}`
                    : `${styles.box} ${styles.boxDrop} ${styles.boxDropComputer}`
            }
            items={{ id, name, type } as DropItems}
            onDrop={validateOnDrop}
            multiple={true}
            dropArea={{pos: pos}}
        >
            {component === 'trash' ? <Trash id={id?.toString()} dropArea={dropArea} css = {css} onclick = {onclick} pos={pos} scale={scale} isLogicMaker={isLogicMaker} size={size} /> : <Computer />}
        </DropBox>
    );
};
